import React from "react";
import { motion } from "framer-motion";

export default function KPICard({ title, value, subtitle, icon: Icon, accent = "default", testid, delay = 0 }) {
  const accents = {
    default: "text-slate-950",
    success: "text-emerald-600",
    danger: "text-red-600",
    info: "text-blue-600",
  };
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay, ease: "easeOut" }}
      data-testid={testid}
      className="relative rounded-2xl bg-white border border-slate-100 p-5 shadow-sm hover:shadow-md transition-shadow duration-200"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="text-[11px] uppercase tracking-[0.16em] text-slate-400 font-semibold leading-tight">
          {title}
        </div>
        {Icon && (
          <div className="w-8 h-8 rounded-lg bg-slate-50 flex items-center justify-center text-slate-500">
            <Icon className="w-4 h-4" />
          </div>
        )}
      </div>
      <div className={`mt-4 font-heading font-bold tracking-tight text-2xl md:text-[26px] tabular-nums ${accents[accent]}`}>
        {value}
      </div>
      {subtitle && <div className="mt-1 text-xs text-slate-500">{subtitle}</div>}
    </motion.div>
  );
}
